import { DispatchPanel } from "./DispatchPanel";
import { TripPanel } from "./TripPanel";

export const Trip = () => {
  return (
    <div className="flex flex-col items-start gap-5">
      <TripPanel />
      <DispatchPanel />
    </div>
  );
};

Trip.TripPanel = TripPanel;
Trip.DispatchPanel = DispatchPanel;
